/* ============================================================
   PDP Acne sticky CTA — hides itself whenever any other
   add-to-cart button is on screen, so two buy buttons are never
   competing for the same tap.

   Targets every add-to-cart form on the page rather than a fixed
   list of classes, so sections added later are picked up with no
   change here. The bar's own button is excluded.
   ============================================================ */

(() => {
  const BAR = '.pdp-acne-sticky-cta';
  const ATC_BUTTONS = '[data-type="add-to-cart-form"] button[type="submit"]';

  let observer = null;

  const setup = () => {
    // Theme editor re-renders call this again; drop the old observer
    // so watchers do not stack up across section reloads.
    observer?.disconnect();
    observer = null;

    const bar = document.querySelector(BAR);
    if (!bar) return;

    const targets = [...document.querySelectorAll(ATC_BUTTONS)].filter(
      (button) => !button.closest(BAR),
    );

    if (!targets.length) {
      bar.classList.remove('is-hidden');
      return;
    }

    const visible = new Set();

    observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            visible.add(entry.target);
          } else {
            visible.delete(entry.target);
          }
        }
        bar.classList.toggle('is-hidden', visible.size > 0);
      },
      { threshold: 0 },
    );

    for (const target of targets) observer.observe(target);
  };

  if (document.readyState !== 'loading') {
    setup();
  } else {
    document.addEventListener('DOMContentLoaded', setup);
  }

  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:unload', setup);
})();
